import contributorRoles from "astrid-firestore/src/api/articles/constants/contributorRoles";
import getContributorNamesByRole from "astrid-firestore/src/api/contributors/utils/getContributorNamesByRole";

export default function getAuthorNames(production) {
	if (production.contributors?.length > 0) {
		return getContributorNamesByRole(production.contributors, contributorRoles.AUTHOR).join(", ");
	}

	return Object.values(production.authorOptions || {})
		?.map((author) => author.text)
		?.filter((v) => v)
		.join(", ");
}
